import { PushpinIcon } from '@panwds/icons';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import { useTableLayoutEnabled, useTableLayoutHeaderTitleEnabled } from '../TableLayout/index.js';
import { DragHandle } from './DragHandle.js';
import { SortButton } from './SortButton.js';
import { calcHeaderClassName } from './header_cell.logic.js';
const OrderableHeaderCell = SortableElement((props) => React.createElement("div", { ...props }));
const Handle = SortableHandle(DragHandle);
export function HeaderCell({ uppercaseHeaderColumns = false, column, index, orderable = false, lastCell = false, lastGroup = false, stickyLeft = false, stickyRight = false }) {
    const resizerProps = column.canResize ? column.getResizerProps() : null;
    const tableLayoutHeaderTitleEnabled = useTableLayoutHeaderTitleEnabled();
    const tableLayoutEnabled = useTableLayoutEnabled();
    const intl = useIntl();
    /* istanbul ignore next */
    const onMouseDown = useCallback((e) => {
        if (resizerProps) {
            const { onMouseDown } = resizerProps;
            e.preventDefault();
            onMouseDown(e);
        }
    }, [resizerProps]);
    const sortDirection = column.isSortedDesc ? 'descending' : column.isSorted ? 'ascending' : 'none';
    const className = calcHeaderClassName({
        uppercaseHeaderColumns,
        lastCell,
        tableLayoutHeaderTitleEnabled,
        lastGroup,
        stickyLeft,
        stickyRight,
        tableLayoutEnabled
    });
    const Comp = orderable ? OrderableHeaderCell : 'div';
    return (React.createElement(React.Fragment, null,
        React.createElement(Comp, { "aria-sort": sortDirection, "data-table-column-id": column.id, ...column.getHeaderProps(), className: className, index: index },
            React.createElement("div", { className: "tw-flex tw-leading-5" },
                React.createElement("div", { className: "tw-truncate" }, column.render('Header')),
                React.createElement(SortButton, { column: column }),
                (stickyLeft || stickyRight) && (React.createElement("button", { type: "button", className: "tw-flex tw-items-center tw-ml-2 tw-border-none tw-bg-transparent tw-m-0 tw-p-0 tw-opacity-0 group-hover:tw-opacity-100 focus:tw-opacity-100 focus:outline-none focus-visible:ring" },
                    React.createElement(PushpinIcon, { size: "xs", className: "tw-text-gray-400 dark:tw-text-blue-400" }))),
                orderable && (React.createElement("div", { className: "tw-flex-auto tw-flex tw-justify-end" },
                    React.createElement(Handle, { label: intl.formatMessage({
                            defaultMessage: 'Drag to reorder',
                            id: 'U/boik',
                            description: 'Move column'
                        }), addClassName: "tw-flex tw-items-center tw-border-none tw-bg-transparent tw-opacity-0 group-hover:tw-opacity-100 focus:tw-opacity-100 tw-text-gray-600 dark:tw-text-dark-bg" })))),
            resizerProps && !lastCell && (React.createElement("div", { ...resizerProps, onMouseDown: onMouseDown, className: "tw-absolute tw-right-0 tw-h-full tw-w-2 tw-top-0" })))));
}
//# sourceMappingURL=HeaderCell.js.map